import request from '@/utils/request'
import { getToken } from '../../utils/auth'

// 查询补贴
export function querysubsidy (params, data) {
  params.token = getToken()
  return request({ url: '/querysubsidy', method: 'post', params, data })
}

// 创建补贴
export function createsubsidy (data) {
  return request({ url: '/createsubsidy', method: 'post', params: { token: getToken() }, data })
}

// 更新补贴
export function updatesubsidy (data) {
  return request({ url: '/updatesubsidy', method: 'post', params: { token: getToken() }, data })
}

// 删除补贴
export function deletesubsidy (data) {
  return request({ url: '/deletesubsidy', method: 'post', params: { token: getToken() }, data })
}



// WEBPACK FOOTER //
// ./src/api/yanglaoyuan/subsidyManage.js